"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _default = exports["default"] = {
  elements: {
    tooltip: {
      primary: '#ffffff',
      warning: '#f8e71c',
      error: '#f9eaec'
    },
    button: {
      primary: (0, _styledComponents.css)(["background-color:#007aff;color:#fff;", " ", ""], function (props) {
        return !props.disabled && "\n          :hover {\n            background-color: #288fff;\n          }\n          \n          :active {\n            background-color: #0071ec;\n          }\n        ";
      }, function (props) {
        return props.disabled && "\n          background-color: #c2c5cc;\n        ";
      })
    }
  },
  colors: {
    white: '#ffffff',
    black: '#000000',
    grey: '#262729',
    blue: '#007aff',
    greyLight: '#919499',
    frenchGray: '#c2c5cc'
  },
  shape: {
    borderRadius: '4px',
    borderRadiusBig: '6px'
  }
};